import initializeFormCoverageConfig from './initializeFormCoverageConfig';
import toggleCoverageConfigModal from './toggleCoverageConfigModal';

export default (item) => (dispatch) => {
    dispatch(initializeFormCoverageConfig(item));
    dispatch(toggleCoverageConfigModal(true));
};
